/** Shared formatting of audit timestamps and date-range filters. */

import { localDayEndIso, localDayStartIso } from '@/utils';

/** Timestamp in the browser's local time zone. */
export function formatDateTime(value: string): string {
	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return '—';
	return new Intl.DateTimeFormat('en-US', {
		year: 'numeric',
		month: 'short',
		day: '2-digit',
		hour: '2-digit',
		minute: '2-digit',
		second: '2-digit',
		hour12: false,
	}).format(date);
}

/** 00:00 local of the selected day, as an ISO UTC instant. */
export function fromIso(date: string): string | undefined {
	return date === '' ? undefined : localDayStartIso(date);
}

/** `to` is exclusive: 00:00 local of the next day includes the whole day. */
export function toIso(date: string): string | undefined {
	return date === '' ? undefined : localDayEndIso(date);
}
